import { Controller } from "@hotwired/stimulus"

// This controller is used to show and hide the sidepanel on the leads list page, the open and close functions
// are triggered using stimulus actions.
export default class extends Controller {
  static get targets() {
    return ["sidePanel", "overlay"]
  }

  // e: CustomEvent
  // e.params.overlay: Boolean?
  // e.params.size: String? (lg)
  open(e) {
    const overlayParam = e.params.overlay
    const sizeParam = e.params.size

    this.sidePanelTarget.setAttribute("aria-hidden", "false")

    if (this.hasOverlayTarget && (overlayParam || overlayParam === "true")) {
      this.overlayTarget.classList.remove("invisible")
      this.overlayTarget.classList.add("is-visible")
    }

    if (sizeParam) {
      this.sidePanelTarget.classList.add(`master-details__details--${sizeParam}`)
    } else {
      this.sidePanelTarget.classList.remove(`master-details__details--lg`)
    }
  }

  close() {
    this.sidePanelTarget.setAttribute("aria-hidden", "true")

    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("is-visible")

      setTimeout(() => {
        this.overlayTarget.classList.add("invisible")
      }, 500)
    }

    const turboMountControllerElement = this.sidePanelTarget.querySelector("[data-controller*='turbo-mount']")
    if (turboMountControllerElement) {
      const stimulusController = Stimulus.getControllerForElementAndIdentifier(
        turboMountControllerElement,
        turboMountControllerElement.dataset.controller,
      )

      if (stimulusController) {
        stimulusController.disconnect() // We do that to unmount the react component as well
      }
    }
  }

  // Close sidepanel when clicking on overlay
  closeOnOverlayClick(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }
}
